import {Pipe, PipeTransform} from '@angular/core';
import {ChallengeAlert} from 'src/app/core/model/project';

const WEEKDAY_LETTERS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

@Pipe({
  name: 'notificationDays',
  standalone: true,
})
export class NotificationDaysPipe implements PipeTransform {
  transform(alert: ChallengeAlert, cycleLength: number): {label: string; selected: boolean}[] {
    if (cycleLength === 7) {
      return WEEKDAY_LETTERS.map((letter, i) => ({
        label: letter,
        selected: alert.days.includes(i),
      }));
    }
    return Array.from({length: cycleLength}, (_, i) => ({
      label: `day ${i + 1}`,
      selected: alert.days.includes(i),
    }));
  }
}
